import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { APP_URLS } from '../helpers/url_helper';
import sessionManager from '../helpers/session_manager';

const ProtectedRoute = () => {
  // Use session manager to check authentication
  const isAuthenticated = sessionManager.isAuthenticated();
  
  // Force re-render and prevent caching
  useEffect(() => {
    // Clear any cached data if not authenticated
    if (!isAuthenticated) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [isAuthenticated]);

  return isAuthenticated ? <Outlet /> : <Navigate to={APP_URLS.LOGIN} replace />;
};

export default ProtectedRoute; 